var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"l-drawer__item"},[_c('router-link',{staticClass:"l-drawer__link c-batch",attrs:{"to":_vm.href}},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"c-badge"},[_vm._v("1")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }